// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CxIH","left":"styles_left__3eg2u","desktopActions":"styles_desktopActions__D0AoL","title":"styles_title__2zxXB"};